<div class="container padding-top padding-bottom">
  <md-card>
    <div class="row padding-bottom">
      <div class="col-md-12">
        <button class='btn btn-lg btn-primary'
                color="primary"
                (click)="goBack()">Go Back</button>
        <button class="btn btn-lg btn-accent float-right"
                color="accent"
                [routerLink]="['../forms/variables']">Variables</button>
      </div>
      <div class="col-md-12 text-center">
        <img src="{{ clientData?.logoUrl }}"
             class="logo"
             alt="">
        <h1>{{clientData?.name}}</h1>
        <h3><b>{{locationData?.name}}</b></h3>
        <ng-container *ngIf="locationData.showMoveInContract">
          <div *ngIf="locationData.moveInContractType == 'sitelink'; else otherEsign">
            <select [(ngModel)]="selectedUnitId">
              <option value="nope">select unit</option>
              <option *ngFor="let unit of availableUnitsByUnitTypeData"
                      [value]="unit.unitId">
                {{unit.width}}' x {{unit.length}}' {{unit.unitType}}
              </option>
            </select>
            <button class='btn btn-lg btn-primary'
                    (click)="testSitelinkEsign()">Test Lease</button>

            <div *ngIf="leasePreviewUrl"
                 class="lease-preview-url-wrapper"
                 class="my-4">
              <p class="m-0">
                <label for="lease-url-input">Open in a private tab (cmd+shift+N)</label>
              </p>
              <input id="lease-url-input"
                     style="width:466px;max-width:95%;"
                     pInputText
                     [ngModel]="leasePreviewUrl" />
              <div class="custom-tooltip">
                <button class="btn btn-secondary"
                        (click)="copyUrlToClipboard()"
                        (mouseout)="outFunc()">
                  <span class="custom-tooltiptext"
                        id="tooltip-action-text">Copy to clipboard</span>
                  <i class="fa fa-clipboard"
                     aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
          <ng-template #otherEsign>
            <div style="float: right">
              <button class='btn btn-lg btn-primary'
                      (click)="createForm()">Create Lease</button>
            </div>
          </ng-template>
        </ng-container>
      </div>
    </div>

    <div class="row padding-bottom">
      <div class="col-md-4 col-md-offset-4">
        <h4>Move In Lease <md-slide-toggle [(ngModel)]="locationData.showMoveInContract"
                           (change)="updateClientFormsToggle('showMoveInContract', $event)"
                           [disabled]="moveInFormsToggleDisabled"></md-slide-toggle>
        </h4> View Variables <a href="https://storagepug.helpdocs.io/article/0hhjfq3fqw/preview"
           target="_blank">HERE</a>

        <hr>
        <div *ngIf="locationData.showMoveInContract"
             class="btn-group"
             style="margin-left: auto; margin-right: auto; display: grid;">
          <label class="btn btn-lg btn-warning"
                 (click)="setLeaseType('sitelink')"
                 [(ngModel)]="leaseTypes.sitelink"
                 btnCheckbox>Sitelink eSign</label>
          <label class="btn btn-lg btn-warning"
                 (click)="setLeaseType('pugSign')"
                 [(ngModel)]="leaseTypes.pugSign"
                 btnCheckbox>Pug Sign</label>
          <label class="btn btn-lg btn-warning"
                 (click)="setLeaseType('helloSign')"
                 [(ngModel)]="leaseTypes.helloSign"
                 btnCheckbox>HelloSign</label>
          <!-- <label class="btn btn-lg btn-warning"
                 (click)="setLeaseType('blueMoon')"
                 [(ngModel)]="leaseTypes.blueMoon"
                 btnCheckbox>Blue Moon (Sitelink eSign)</label> -->
        </div>

        <div *ngIf="locationData.moveInContractType == 'helloSign'">
          <br>
          <hr>
          <h4>Instructions:</h4>
          <p>- Log into Hellosign</p>
          <p>- Create a new API app</p>
          <p>- Name: PugSign CLIENT NAME</p>
          <p>- Use the client's website URL</p>
          <p>- Don't enable OAuth</p>
          <p>- Create the app</p>
          <p>- Paste the Client ID below</p>
          <p>- Create the lease template</p>
          <p>- Paste the template ID on the edit page for the lease</p>
          <p>- If you do not assign ALL unit types to a lease, YOU WILL REGRET IT!</p>
          <div>
            <input pInputText
                   class="full-width"
                   placeholder="HelloSign Client ID"
                   (change)="updateLocation()"
                   [(ngModel)]="locationData.helloSignClientId" />
          </div>
        </div>
        <div *ngIf="locationData.moveInContractType == 'blueMoon'">
          <br>
          <hr>
          <h4>Instructions:</h4>
          <p>- Log onto Sitelink and go to Setup</p>
          <p>- Form Setup</p>
          <p>- Click on the Blue Moon Form and then click save</p>
          <p>- Fill in the clients blueMoon creds (To change property number Hold down control+Shift+e.)</p>
          <p>- Click on SitelinkEsign to make sure that you have that turned on. BlueMoon's lease gets sent through
            Sitelink's API call</p>
        </div>
        <div *ngIf="locationData.moveInContractType == 'pugSign'">
          <br>
          <hr>
          <h4>Instructions:</h4>
          <p>- If you do not assign ALL unit types to a lease, when you leave this page it will AUTOMATICALLY TURN
            OFF!</p>
        </div>
        <div *ngIf="locationData.moveInContractType == 'sitelink'">
          <br>
          <hr>
          <h4>Instructions:</h4>
          <p>Make sure this client has leases set up for their units in Sitelink!</p>
        </div>
      </div>
    </div>

    <!-- <div *ngIf="locationData.showMoveInContract && locationData.moveInContractType == 'blueMoon'" class="row ">
      <div class="col-md-12 margin-bottom data-table">
        <h4>Move In Forms</h4>
        <div class="ui-widget-header" style="padding:4px 10px;border-bottom: 0 none">
          <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
          <input #moveInSearch type="text" pInputText placeholder="Search" style="width: 250px !important;">
          <button class="btn btn-primary btn-lg float-right" (click)="saveClientForms()">Save</button>

        </div>
        <p-dataTable *ngIf="locationData?.moveInContract" [value]="allForms | async" scrollable="true" scrollHeight="250px" [globalFilter]="moveInSearch" #moveInFormsTable [(selection)]="locationData.moveInContract">
          <p-column [style]="{'width':'38px'}" selectionMode="multiple"></p-column>
          <p-column field="name" header="Name" [sortable]="true"></p-column>
          <p-column field="categoryName" header="Category" [sortable]="true"></p-column>
          <p-column field="availableAtMoveIn" header="Available At Move In" [sortable]="true"></p-column>
          <p-column field="isPrintPreview" header="Is Print Preview" [sortable]="true"></p-column>
          <p-column field="formRtf" header="RTF" [sortable]="true">
            <ng-template let-col let-car="rowData" pTemplate="body">
              <div *ngIf="car['formRtf'] && car['formRtf'] != 'none'">Y</div>

            </ng-template>
          </p-column>
          <p-column field="formHtml" header="HTML" [sortable]="true">
            <ng-template let-col let-car="rowData" pTemplate="body">
              <div *ngIf="car['formHtml'] && car['formHtml'] != 'none'">Y</div>
            </ng-template>
          </p-column>
        </p-dataTable>
      </div>
    </div> -->

    <div *ngIf="locationData.showMoveInContract && locationData.moveInContractType != 'blueMoon' && locationData.moveInContractType != 'sitelink'"
         class="row">
      <div class="col-sm-4 col-sm-offset-1">
        <div class="card card-outline-primary mb-3"
             *ngFor="let form of locationFormsArray"
             droppable
             [dragOverClass]="'drag-target-border-green'"
             [dropScope]="'default'"
             (onDrop)="addUnitTypeToLease($event, form)"
             [dragHintClass]="'drag-hint'">
          <div style="padding:10px">
            <md-slide-toggle [(ngModel)]="form.isDefault"
                             (change)="updateDefaultLease($event, form)">Default</md-slide-toggle>
          </div>
          <div class="card-header card-inverse card-primary">{{ form?.name }}
            <a (click)="deleteForm(form)"
               class="btn btn-xs btn-default float-right"
               style="cursor: pointer"
               aria-hidden="true">Delete</a>
            <a [routerLink]="['../forms/' + form?.$key]"
               class="btn btn-xs btn-default float-right"
               style="cursor: pointer"
               aria-hidden="true">Edit</a>
          </div>
          <div class="card-block scroll-list">
            <li *ngFor="let item of form.units"
                class="list-group-item"
                [draggable]
                [dragClass]="'active'"
                [dragData]="item"
                [dragScope]="'default'">{{item.name}}</li>
          </div>
        </div>
      </div>
      <div class="col-sm-4 col-sm-offset-2">
        <div class="card card-outline-success mb-3"
             droppable
             [dragOverClass]="'drag-target-border-green'"
             [dropScope]="'default'"
             (onDrop)="addUnitTypeToUnitTypes($event)"
             [dragHintClass]="'drag-hint'">
          <div class="card-header card-inverse card-success">
            Unit Types
          </div>
          <div class="card-block scroll-list">
            <div class="list-group">
              <li class="list-group-item list-group-item-action list-group-item-success"
                  [draggable]
                  *ngFor="let item of unitTypes"
                  [dragClass]="'active'"
                  [dragData]="item"
                  [dragScope]="'default'">
                {{ item.name }}
              </li>
            </div>
          </div>
        </div>
      </div>
    </div>

  </md-card>
</div>



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/forms-create-leases/forms-create-leases.component.html